import React from "react";

const PhoneSimulatorFooter = ({children}) => {

    return (
        <>
            <div className={'phone-simulator-footer'}>
                {children}
            </div>
        </>
    )
}

export default PhoneSimulatorFooter;
